import React from 'react';
import { Container } from 'react-bootstrap';

export const Layout = (props) => (
  <Container style={{padding: '1%'}}>
    {props.children}
  </Container>
)
